<template>
    <div>
        <TolesApplicationLayout>
            <div class="col-10 col-sm-7 col-md-5 col-lg-8 col-xl-7 col-xxl-6 login-wrapper py-5">
                <ValidationObserver ref="loginForm">
                    <div class="row">
                        <div class="col-12 mt-4">
                            <ValidationProvider name="nationalId" rules="required" v-slot="{valid, errors}">
                                <b-form-group :label="$t('national_number')" class="input-icon position-relative">
                                    <b-form-input
                                        :type="loginPasswordShowStatus ? 'text':'password'"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                        v-model="loginForm.nationalId"></b-form-input>
                                    <i class="ri-eye-close-line w-40 h-40 position-absolute d-flex align-items-center justify-content-center right-0 top-0 cursor-pointer"
                                       @click="loginPasswordShowStatus=true"
                                       v-if="!loginPasswordShowStatus"></i>
                                    <i class="ri-eye-2-line w-40 h-40 position-absolute d-flex align-items-center justify-content-center right-0 top-0 cursor-pointer"
                                       @click="loginPasswordShowStatus=false"
                                       v-if="loginPasswordShowStatus"></i>
                                    <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                </b-form-group>
                            </ValidationProvider>
                        </div>
                        <div class="col-12">
                            <ValidationProvider name="pinCode" rules="required" v-slot="{valid, errors}">
                                <b-form-group :label="$t('pin_code')" class="input-icon position-relative">
                                    <b-form-input
                                        :type="loginPasswordShowStatusPin ? 'text':'password'"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                        v-model="loginForm.pinCode"></b-form-input>
                                    <i class="ri-eye-close-line w-40 h-40 position-absolute d-flex align-items-center justify-content-center right-0 top-0 cursor-pointer"
                                       @click="loginPasswordShowStatusPin=true"
                                       v-if="!loginPasswordShowStatusPin"></i>
                                    <i class="ri-eye-2-line w-40 h-40 position-absolute d-flex align-items-center justify-content-center right-0 top-0 cursor-pointer"
                                       @click="loginPasswordShowStatusPin=false"
                                       v-if="loginPasswordShowStatusPin"></i>
                                    <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                </b-form-group>
                            </ValidationProvider>
                        </div>
                        <div class="col-12">
                            <b-button @click="login" block variant="primary">{{ $t('login').toUpper() }}</b-button>
                        </div>
                        <div class="col-12">
                            <b-button @click="toForm" block variant="link">{{$t('sign_up').toUpper()}}</b-button>
                        </div>
                    </div>
                </ValidationObserver>

            </div>

        </TolesApplicationLayout>
    </div>
</template>
<script>

import {ValidationObserver, ValidationProvider} from "vee-validate";
import GraduateApplicationService from "@/services/GraduateApplicationService";
import TolesApplicationLayout from "@/layouts/TolesApplicationLayout.vue";
import TolesApplicationServices from "@/services/TolesApplicationServices";

export default {
    name:"Login",
    components: {
        ValidationObserver,
        ValidationProvider,
        TolesApplicationLayout
    },
    metaInfo() {
        return {
            title: this.$t('toles_application_form')
        }
    },
    data() {
        return {
            loginForm: {
                nationalId: null,
                pinCode: null
            },
            loginPasswordShowStatus: false,
            loginPasswordShowStatusPin: false,
        }
    },
    created() {
        const tolesUser =localStorage.getItem('toles_application_user')?JSON.parse(localStorage.getItem('toles_application_user')):null;
        const pin =localStorage.getItem('pin')?JSON.parse(localStorage.getItem('pin')):null
        const sessionExpiryTime =localStorage.getItem('sessionExpiryTime')?JSON.parse(localStorage.getItem('sessionExpiryTime')):null
        const successPayment =localStorage.getItem('paymentSucces')
        if (tolesUser || pin || sessionExpiryTime){
            this.logout()
        }
        if (successPayment){
            localStorage.removeItem('paymentSucces')
        }
    },

    watch: {},
    methods: {
        async login() {
            const isValid = await this.$refs.loginForm.validate();
            if(isValid){
                let formData = {
                    national_id: this.loginForm.nationalId,
                    pin: this.loginForm.pinCode,
                    sort:'-payment_status'
                }
                TolesApplicationServices.login(formData).then(response => {
                         let data = response.data.data
                          localStorage.setItem('toles_application_user',JSON.stringify(data))
                          localStorage.setItem('pin',JSON.stringify(formData.pin))
                         this.$router.push('/toles/application/form')
                }).catch(e => {
                    this.showErrors(e,this.$refs.loginForm)
                }).finally(()=>{
                    this.loginForm.nationalId = null
                    this.loginForm.pinCode = null
                })
            }
        },
        toForm(){
            this.$router.push('/toles/application/register')
        },
        logout(){
            this.$store.dispatch('TolesApplicationStore/logout')
        }
    },
};
</script>

